export const CONTACT_TYPE_CONTACT   = 'Contact';
export const CONTACT_TYPE_EMERGENCY = 'Emergency';

export const isEmergencyContact = (type) =>
  String(type || '').trim().toLowerCase().startsWith('emerg');

export const contactTypeFor = (isEmergency) =>
  (isEmergency ? CONTACT_TYPE_EMERGENCY : CONTACT_TYPE_CONTACT);